import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useContext, useState } from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import get from "lodash/get";
import { withStoreContext } from "gatsby-plugin-shopify-buy";

import { GlobalDispatchContext, GlobalStateContext } from "../../context";
import TrashIcon from "../trashIcon";
import KCSpinner from "Components/common/KCSpinner";
import CurrencyData from "Components/common/intlPopup/currencyData";

const StyledCard = styled.div`
  display: flex;
  font-family: ${(props) => props.theme.font.sans};
  align-items: center;
  margin-bottom: 0.6rem;
  position: relative;
`;

const StyledLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${(props) => (props.isShown ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  background-color: ${(props) => props.theme.color.white};
  z-index: 1;
`;

const StyledRenderWrapper = styled.div`
  height: 6rem;
  width: 6rem;
  background-color: ${(props) => props.theme.color.smoke};
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.theme.responsive.mobile} {
    height: 5rem;
    width: 5rem;
  }
`;

const StyledRender = styled.img`
  margin: 0.25rem;
  width: calc(100% - 0.5rem ");
  height: calc(100% - 0.5rem");
`;

const StyledFrameDescriptionWrapper = styled.div`
  margin-left: 1rem;
  display: flex;
  align-items: stretch;
  flex: 1;
`;

const StyledFrameTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledTitle = styled.div`
  font-weight: 600;
  font-size: 1.3rem;
  ${(props) => props.theme.responsive.mobile} {
    font-size: 1rem;
  }
`;

const StyledSubtitle = styled.div`
  font-size: 0.7rem;
  color: ${(props) => props.theme.color.dimGrey};
  line-height: 1rem;
  ${(props) => props.theme.responsive.mobile} {
    line-height: 0.9rem;
    font-size: 0.6rem;
  }
`;

const StyledFramePriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

const StyledQuantityWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const StyledQuantityPicker = styled.div`
  display: flex;
  width: 3rem;
  height: 1.2rem;
  background-color: ${(props) => props.theme.color.smoke};
  position: relative;
  margin-right: 0.8rem;
  border-radius: 2px;
  color: ${(props) => props.theme.color.dimGrey};
`;
const StyledQuantityButton = styled.div`
  width: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.7rem;
  color: ${(props) => props.theme.color.grey};
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.darkGrey};
  }
`;
const StyledQuantityInput = styled.input`
  height: 100%;
  padding: 2px 0;
  width: 1rem;
  background-color: transparent;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${(props) => props.theme.color.smoke};
  border-radius: 2px;
  color: ${(props) => props.theme.color.dimGrey};
  font-size: 0.7rem;
  font-weight: bold;

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const StyledPrice = styled.div`
  font-weight: bold;
  font-size: 1rem;
  color: ${(props) => props.theme.color.darkGrey};
  ${(props) => props.theme.responsive.mobile} {
    font-size: 0.8rem;
  }
`;

const SKUCard = ({
  img,
  curFrame,
  storeContext,
  currency,
  price,
  ...props
}) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const { selectedOptions } = curFrame.variant;
  const intl = useIntl();
  const [isRemoveLoading, setIsRemoveLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);

  const handleRemoveBag = (lineID) => {
    if (state.shopifyCheckout.id === undefined) {
      //TODO ERROR
      return;
    }
    setIsRemoveLoading(true);
    storeContext.client.checkout
      .removeLineItems(state.shopifyCheckout.id, [lineID])
      .then((checkout) => {
        dispatch({ type: "UPDATE_BAG", shopifyCheckout: checkout });
        setIsRemoveLoading(false);
      })
      .catch((error) => {
        setIsRemoveLoading(false);
      });
  };

  const handleUpdateBag = (lineID, quantity) => {
    if (state.shopifyCheckout.id === undefined) {
      //TODO ERROR
      return;
    }
    setIsUpdateLoading(true);
    storeContext.client.checkout
      .updateLineItems(state.shopifyCheckout.id, [
        { id: lineID, quantity: quantity },
      ])
      .then((checkout) => {
        dispatch({ type: "UPDATE_BAG", shopifyCheckout: checkout });
        setIsUpdateLoading(false);
      })
      .catch((error) => {
        setIsUpdateLoading(false);
      });
  };
  return (
    <StyledCard>
      <StyledLoadingOverlay isShown={isUpdateLoading || isRemoveLoading}>
        <KCSpinner color="black" isShown={isUpdateLoading || isRemoveLoading} />
      </StyledLoadingOverlay>
      <StyledRenderWrapper line={curFrame.line}>
        <StyledRender
          line={curFrame.line}
          src={img}
          alt="Product"
        ></StyledRender>
      </StyledRenderWrapper>
      <StyledFrameDescriptionWrapper>
        <StyledFrameTextWrapper>
          <StyledTitle>{get(curFrame, "title", "")}</StyledTitle>
          <StyledSubtitle>
            Lens: {selectedOptions.find((o) => o.name === "Lens").value}
          </StyledSubtitle>
          <StyledSubtitle>
            Frame: {selectedOptions.find((o) => o.name === "Color").value}
          </StyledSubtitle>
          <StyledSubtitle>
            Size:
            {` ${intl.formatMessage({
              id: `product.sizes.${
                selectedOptions.find((o) => o.name === "Size").value
              }.name`,
            })}`}
          </StyledSubtitle>
        </StyledFrameTextWrapper>
        <StyledFramePriceWrapper>
          <StyledQuantityWrapper>
            <StyledQuantityPicker>
              <StyledQuantityButton
                onClick={() =>
                  handleUpdateBag(
                    curFrame.id,
                    Math.max(0, curFrame.quantity - 1)
                  )
                }
              >
                –
              </StyledQuantityButton>
              <StyledQuantityInput
                disabled
                type="number"
                value={curFrame.quantity}
              />
              <StyledQuantityButton
                onClick={() =>
                  handleUpdateBag(curFrame.id, curFrame.quantity + 1)
                }
              >
                +
              </StyledQuantityButton>
            </StyledQuantityPicker>
            <TrashIcon handlerClick={() => handleRemoveBag(curFrame.id)} />
          </StyledQuantityWrapper>
          <StyledPrice>
            {CurrencyData[currency]}
            {price}
          </StyledPrice>
        </StyledFramePriceWrapper>
      </StyledFrameDescriptionWrapper>
    </StyledCard>
  );
};

export default withStoreContext(SKUCard);
